
const state = {
  tagObject: null
}

const getters = {
  tagObject: state => {
    return state.tagObject
  }
}

const actions = {
}

const mutations = {
  SET_TAGOBJECT (state, tagObject) {
    state.tagObject = tagObject
  },
  SET_TAGCOLOR (state, color) {
    state.tagObject.color = color
  },
  SET_DESCRIPTION (state, desc) {
    state.tagObject.description = desc
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
